import React from 'react';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';
import Navbar, {Brand} from 'react-bootstrap/lib/Navbar';
import Stopwatch from '../stopwatch/stopwatch';
import ActionButton from '../button/action_button';
import SubmitButton from '../button/submit_button';
import CharField from '../field/char_field';
import DateField from '../field/date_field';
import SelectAwesomplete from '../field/select_awesomplete';
import TextBoxField from '../field/textbox_field';
import IntField from '../field/int_field';
import PasswordField from '../field/password_field';
import ManyToManyField from '../field/many_to_many_field';
import XeditableNumberField from '../field/xeditable/xeditable_number_field';
import XeditableTextField from '../field/xeditable/xeditable_text_field';
import XeditableDateField from '../field/xeditable/xeditable_date_field';
import SignatureCanvas from 'react-signature-canvas'
import ProgressBarAutoRun from '../progress_bar/progress_bar';
import ProgressBarAutoRunRedirect from '../progress_bar/progress_bar_autorun_redirect';
import CharWithIconAddon from '../field/char_with_icon_addon';
import SignaturePadToData from '../field/signature_pad';
import VideoBackground from '../video/video_background';
import ReactMultiSelect from '../field/react_multi_select';
import TimeField from '../field/antd_time_picker';
import CharParsedTime from '../field/char_parsed_time_field';
import SignaturePadRedirect from '../field/signature_pad_redirect';
import XeditableForeignKeyField from '../field/xeditable/xeditable_edit_foreign_key_field';
import XeditableManyToManyField from '../field/xeditable/xeditable_many_to_many_field';
import XeditableReactMultiSelect from '../field/xeditable/xeditable_react_multi_select'

import { Home, LogOut, CheckSquare, User } from 'react-feather';

import {
    Grid,
    Row,
    Col,
    Jumbotron,
    Button,
    Panel,
    PanelGroup,
    Nav,
    NavItem,
    Label,
    ProgressBar,
    Alert,
    FormControl,
    InputGroup,
    FormGroup,
    Table,
    Tabs,
    Tab,
    Glyphicon,
    Form,
} from 'react-bootstrap';

const Components = {
    User,
    TextBoxField,
    XeditableDateField,
    ProgressBarAutoRunRedirect,
    CheckSquare,
    Home,
    LogOut,
    CharWithIconAddon,
    ProgressBarAutoRun,
    SignaturePadToData,
    Grid,
    Row,
    Col,
    Jumbotron,
    Button,
    Panel,
    PanelGroup,
    Nav,
    NavItem,
    Label,
    ProgressBar,
    Alert,
    FormControl,
    InputGroup,
    FormGroup,
    Table,
    Tabs,
    Tab,
    NavLink,
    Brand,
    Navbar,
    Glyphicon,
    Stopwatch,
    ActionButton,
    CharField,
    DateField,
    Form,
    SelectAwesomplete,
    IntField,
    SubmitButton,
    ManyToManyField,
    XeditableNumberField,
    XeditableTextField,
    VideoBackground,
    PasswordField,
    ReactMultiSelect,
    TimeField,
    CharParsedTime,
    SignaturePadRedirect,
    XeditableForeignKeyField,
    XeditableManyToManyField,
    XeditableReactMultiSelect,
};

export default class Abstract extends React.Component {

    // for xeditable:
    static counter: 0;
    static getCounter = function() {
      return 'counter-' + ++Abstract.counter;
    };
    static resetCounter = function() {
      Abstract.counter = 0;
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loading_screen:true,
            layout: [],
            redirect: false,
            redirect_url: '',
            pathname: '',
            search: '',
            submit_ready: false,
            editingInstance: {},
            displayInstance: {},
            field_to_focus: '',
            refresh: Abstract.getCounter(), // used to redraw the component,
            loading_progress:0,
            initial_loading: true,
            is_mobile:'false',
        };
    }

    componentDidMount = () => {
        //console.log('abstract_base componentDidMount');
        this.setState({pathname:this.props.location.pathname, search: this.props.location.search});
        this.getLayout('/api' + this.props.location.pathname + this.props.location.search);
       
        let ws_scheme = window.location.protocol == 'https:' ? 'wss' : 'ws';
        let ws_path = ws_scheme + '://' + window.location.host + '/log/stream/';
        this.socket = new WebSocket(ws_path);
        this.socket.onmessage = message => {
            let data = JSON.parse(message.data);
            if (data.stream === 'log') {
                //this.getLayout('/api' + this.state.pathname + this.state.search);
                let websocket_model_name = String(data.payload.data.model_name).toLowerCase();
                let websocket_user = String(data.payload.data.user).toLowerCase();
                // console.log('websocket_model_name: ' + websocket_model_name)
                // console.log('websocket_user: ' + websocket_user)
                // console.log('this.state.username');
                // console.log(this.state.username);
                // console.log('this.state.pathname.toLowerCase()');
                // console.log(this.state.pathname.toLowerCase());
                //
                // console.log('this.state.pathname.toLowerCase().includes(websocket_model_name) === true');
                // console.log(this.state.pathname.toLowerCase().includes(websocket_model_name) === true);
                //
                // console.log('this.state.models_that_dont_update_on_everyones_changes');
                // console.log(this.state.models_that_dont_update_on_everyones_changes);

                if (this.state.models_that_dont_update_on_everyones_changes.includes(websocket_model_name)) {
                    if(this.state.username === websocket_user) {
                        // console.log('Websocket firing get_layout() for a model that doesnt update on everyones changes!!!')
                        this.getLayout('/api' + this.state.pathname + this.state.search);

                    }
                } else {
                    // console.log('Websocket firing get_layout()!!!')
                    this.getLayout('/api' + this.state.pathname + this.state.search);
                }
                // if(this.state.pathname.toLowerCase().includes(websocket_model_name) === true) {
                //     if(this.state.username === websocket_user) {
                //         console.log('Websocket firing get_layout()!!!')
                //         this.getLayout('/api' + this.state.pathname + this.state.search);
                //
                //     } else if(this.state.models_that_dont_update_on_everyones_changes.includes(websocket_model_name) == false) {
                //         console.log('Websocket firing get_layout!!!')
                //         this.getLayout('/api' + this.state.pathname + this.state.search);
                //     }
                // }
            }
        };
    }

    componentWillReceiveProps = (nextProps) => {
        //console.log('componentReceivedProps');
        this.setState({pathname:nextProps.location.pathname, search: nextProps.location.search, loading_screen:true});

        this.getLayout('/api' + nextProps.location.pathname + nextProps.location.search);
    }

    getCookie = (c_name) => {
        if(document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + "=");
            if(c_start != -1) {
                c_start = c_start + c_name.length + 1;
                let c_end = document.cookie.indexOf(";", c_start);
                if(c_end == -1) c_end = document.cookie.length;
                return unescape(document.cookie.substring(c_start,c_end));
            }
        } else {
            return "";
        }
    }

    getLayout = (url) => {
        let csrftoken = this.getCookie('csrftoken');
        $.ajax({
            url: url,
            dataType: 'json',
            cache: false,
            statusCode: {
               403: () => {
                 this.setState({redirect_url: '/login/', redirect: true})
               }
            },
            success: (data) => {
                this.setState({
                    redirect: data['redirect'],
                    redirect_url: data['redirect_url'],
                    layout: data['layout'][0],
                    loading: false,
                    loading_screen:false,
                    username: data['username'],
                    models_that_dont_update_on_everyones_changes: data['models_that_dont_update_on_everyones_changes'],
                });
                //console.log('abstract_base getLayout username');
                //console.log(data['username']);
            },
            error: (xhr, status, err) => {
                //console.log('We have an error in getLayout Ajax call')
                //console.log(err.toString());
                // Redirects to 404 Not found server error
                this.setState({redirect_url: '/not_found/', redirect: true})
            }
        });
    }

    clearEditingInstance = () => {
        this.setState({editingInstance: {}, displayInstance: {}});
    }

    onSelectChange = (key, value, label=undefined) => {
        let displayInstance = this.state.displayInstance;
        let editingInstance = this.state.editingInstance;
        // console.log('key');
        // console.log(key);
        // console.log('value');
        // console.log(value);
        editingInstance[key] = value;
        // console.log('editingInstance');
        // console.log(editingInstance);
        let focus = key;
        if (label != undefined) {
            displayInstance[key] = label
        }
        this.setState({editingInstance, focus, displayInstance});
    }

    handleFocus = (field_id) => {
      this.setState({focus:field_id})
    }

    setMessage = (message, type) => {
      Messenger().post({
        id: type,
        type: type,
        singleton: false,
        message: message,
        showCloseButton: false,
        hideAfter:2
      });
    }

    buildLayout = (component, results2) => {
        let results = results2.slice();
        let attributes = {};
        let text = '';
        let content = [];
        let id = Math.random();
        let component_name;
        let object;
        let closed_html_tags = ['img', 'hr', 'br', 'i'];
        let closed_component_tags = [
          'Glyphicon', 'Stopwatch', 'ActionButton', 'CharField', 'DateField',
          'SelectAwesomplete', 'IntField', 'SubmitButton', 'ManyToManyField',
          'SignaturePadToData', 'XeditableNumberField', 'XeditableTextField',
          'ProgressBarAutoRun', 'CharWithIconAddon', 'Home', 'LogOut', 'User',
          'CheckSquare', 'XeditableDateField', 'VideoBackground', 'TextBoxField',
          'PasswordField', 'ReactMultiSelect', 'TimeField', 'CharParsedTime',
          'SignaturePadRedirect', 'XeditableForeignKeyField', 
          'XeditableReactMultiSelect',
        ];

        let components_on_select_change = [
          'CharField', 'DateField', 'SelectAwesomplete', 'IntField',
          'SubmitButton', 'ManyToManyField', 'ActionButton', 'TextBoxField',
          'ProgressBarAutoRun','SignaturePadToData', 'CharWithIconAddon',
          'PasswordField', 'ReactMultiSelect', 'TimeField', 'CharParsedTime',
          'SignaturePadRedirect', 'XeditableForeignKeyField',
          'XeditableManyToManyField', 'XeditableReactMultiSelect',
        ];
        Object.keys(component).forEach((key) => {
            component_name = key;
            let level2 = component[key];
            Object.keys(level2).forEach((key2) => {
                if (level2[key2].hasOwnProperty('attributes')) {
                    attributes = level2[key2]['attributes'][0];
                } else if (level2[key2].hasOwnProperty('text')) {
                    text = level2[key2]['text'];
                } else if (typeof (key2) === 'string') {
                    object = level2[key2];
                    content.push(this.buildLayout(object, results));
                }
            });
        });
        let react = String(component_name).match(new RegExp(/^[A-Z]/)) !== null;
        if (react === true) {
            const Component = Components[`${component_name}`];
            if (closed_component_tags.includes(component_name) === true) {
                if (components_on_select_change.includes(component_name) === true) {
                    results.push(
                        <Component
                            {...attributes}
                            key={id}
                            focus={this.state.focus}
                            editingInstance={this.state.editingInstance}
                            onSelectChange={this.onSelectChange}
                            displayInstance={this.state.displayInstance}
                            clearEditingInstance={this.clearEditingInstance}
                            setMessage={this.setMessage}
                            refresh={this.state.refresh}
                            handleFocus={this.handleFocus}
                        />
                    );
                } else {
                    results.push(
                        <Component {...attributes} key={id} />
                    );
                }
            } else {
                results.push(
                    <Component {...attributes} key={id}>{text} {content}</Component>
                );
            }
        } else {
            const Component = component_name;
            if (closed_html_tags.includes(component_name) === true) {
                results.push(
                    <Component {...attributes} key={id} />
                );
            } else {
                results.push(
                    <Component {...attributes} key={id}>{text} {content}</Component>
                );
            }
        }
        return results;
    }

    render() {
        if (this.state.redirect === true && this.state.redirect_url != '') {
            return <Redirect to={this.state.redirect_url} />;
        }
        let result = [];
        if (this.state.loading == false) {
            let layout = this.state.layout;
            result = this.buildLayout(layout, []);
        }
        let overlay_class = this.state.loading_screen ? "overlay" : "overlay_off";
        return (
            <div>
                <div>
                    {result}
                </div>
                <div className={overlay_class} />
            </div>
        );
    }
}

Abstract.propTypes = {
    location: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/helpers/base/abstract_base.js